// extracted by mini-css-extract-plugin
module.exports = {"role-assignments":"role-assignments--2Sfa6wSpJg","roleAssignments":"role-assignments--2Sfa6wSpJg"};